(() => {
  // Shopify can return a regional route prefix different from request.locale.
  // Keep content navigation in the visibly rendered language; never rewrite
  // third-party, checkout, account, API, download or explicit language links.
  function localizedUrl(raw, language, origin) {
    if (!raw || raw.startsWith('#') || !['tr', 'en'].includes(language)) return raw;
    let url;
    try { url = new URL(raw, origin); } catch (_) { return raw; }
    if (url.origin !== origin || !/^https?:$/.test(url.protocol)) return raw;
    const path = url.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    if (!/^\/(?:$|(?:pages|policies|blogs|products|collections|search|cart)(?:\/|$))/.test(path)) return raw;
    url.pathname = language === 'en' ? '/en' + (path === '/' ? '' : path) : path;
    if (url.href === new URL(raw, origin).href) return raw;
    return url.pathname + url.search + url.hash;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = localizedUrl; return; }
  const language = document.documentElement.lang.split('-')[0];
  const origin = location.origin;
  const searchUrl = new URL(location.href);
  if (/\/(?:en\/)?search$/.test(searchUrl.pathname) && searchUrl.searchParams.has('q') && !['product', 'article', 'page'].includes(searchUrl.searchParams.get('type'))) {
    searchUrl.searchParams.set('type', 'product');
    location.replace(searchUrl.pathname + searchUrl.search + searchUrl.hash);
    return;
  }
  function updateLink(link) {
    if (link.matches('[hreflang],[data-locale-switch],[download]') || link.closest('localization-form,[data-ep-language]')) return;
    const raw = link.getAttribute('href');
    const fixed = localizedUrl(raw, language, origin);
    if (fixed !== raw) link.setAttribute('href', fixed);
  }
  function updateSearch(form) {
    const raw = form.getAttribute('action');
    if (!raw || !/\/(?:en\/)?search(?:\?|$)/.test(raw) || (form.getAttribute('method') || 'get').toLowerCase() !== 'get') return;
    form.setAttribute('action', localizedUrl(raw, language, origin));
    let type = form.querySelector('input[name="type"]');
    if (!type) { type = document.createElement('input'); type.type = 'hidden'; type.name = 'type'; type.value = 'product'; form.append(type); }
    if (form.matches('[data-search-form]')) {
      const selectedType = new URL(location.href).searchParams.get('type');
      if (['product', 'article', 'page'].includes(selectedType)) type.value = selectedType;
    }
  }
  function update(root) {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
    if (root.matches?.('form[action]')) updateSearch(root);
    root.querySelectorAll?.('form[action]').forEach(updateSearch);
  }
  update(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) update(node); }))).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('click', event => { const a = event.target.closest('a[href]'); if (a) updateLink(a); }, true);
  document.addEventListener('submit', event => updateSearch(event.target), true);
  // The theme's AJAX search uses this route, not the form action.
  if (window.theme?.routes?.searchUrl) window.theme.routes.searchUrl = localizedUrl(window.theme.routes.searchUrl, language, origin);
})();
